module.exports = __webpack_public_path__ + "img/72.34624645.jpg";